import { DEFAULT_LOCALE } from "./i18n";

/**
 * Where the bare `/` sends a visitor: `/en`, with the query and hash kept.
 *
 * Ads and campaign links point at the homepage with `utm_*`, `gclid` and
 * `fbclid` on them. The 301 happens on the server, before `captureFirstTouch()`
 * in the root route can read them, so dropping the query here lost the ad
 * that sent the visitor.
 */
export function homeRedirectHref(href: string): string {
  // `href` is "/", "/?utm_source=x" or "/#y"; drop the leading slash so the
  // result is "/en?utm_source=x", not "/en/?…" (which costs a second 301).
  const rest = href.startsWith("/") ? href.slice(1) : href;
  return `/${DEFAULT_LOCALE}${rest}`;
}
